import { render, staticRenderFns } from "./EditTextHistory.vue?vue&type=template&id=3ff73942&"
import script from "./EditTextHistory.vue?vue&type=script&lang=js&"
export * from "./EditTextHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports